import includes from 'lodash/includes';

const getAnswerResults = (answerId, results) => {
	if (results) {
		const { answers, correct } = results;
		return {
			correct: includes(correct, answerId),
			count: answers[answerId] || 0,
		};
	}
	return {};
};
const getTotalResults = (results) => {
	if (!results) {
		return 0;
	}
	const { answers } = results;
	if (!answers) {
		return 0;
	}
	const answerValues = Object.values(answers);
	return answerValues.length ? answerValues.reduce((a, b) => a + b) : 0;
};

export { getTotalResults, getAnswerResults };
export default getAnswerResults;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/question/utils/getAnswerResults.js